import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Reports } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Reports.Pages.REPORTS}`,
    name: Reports.Pages.REPORTS,
    component: () => import(/* webpackChunkName: "reports" */ './views/Reports.vue'),
    meta: {
      access_roles: RouteRoles[Reports.Pages.REPORTS],
    },
  },
  {
    path: `/${Reports.Pages.REPORT_ORDERS_DETAIL}`,
    name: Reports.Pages.REPORT_ORDERS_DETAIL,
    component: () => import(/* webpackChunkName: "reports" */ './views/ReportsOrdersDetail.vue'),
    meta: {
      access_roles: RouteRoles[Reports.Pages.REPORT_ORDERS_DETAIL],
    },
  },
  {
    path: `/${Reports.Pages.REPORT_SALES_DETAIL}`,
    name: Reports.Pages.REPORT_SALES_DETAIL,
    component: () => import(/* webpackChunkName: "reports" */ './views/ReportsSalesDetail.vue'),
    meta: {
      access_roles: RouteRoles[Reports.Pages.REPORT_SALES_DETAIL],
    },
  },
  {
    path: `/${Reports.Pages.REPORTS_MUTUAL_DETAIL}`,
    name: Reports.Pages.REPORTS_MUTUAL_DETAIL,
    component: () => import(/* webpackChunkName: "reports" */ './views/ReportsMutualDetail.vue'),
    meta: {
      access_roles: RouteRoles[Reports.Pages.REPORTS_MUTUAL_DETAIL],
    },
  },
  {
    path: `/${Reports.Pages.REPORTS_REPAIRS_DETAIL}`,
    name: Reports.Pages.REPORTS_REPAIRS_DETAIL,
    component: () => import(/* webpackChunkName: "reports" */ './views/ReportsRepairsDetail.vue'),
    meta: {
      access_roles: RouteRoles[Reports.Pages.REPORTS_REPAIRS_DETAIL],
    },
  },
  {
    path: `/${Reports.Pages.REPORTS_SERVICE_DETAIL}`,
    name: Reports.Pages.REPORTS_SERVICE_DETAIL,
    component: () => import(/* webpackChunkName: "reports" */ './views/ReportsServiceDetail.vue'),
    meta: {
      access_roles: RouteRoles[Reports.Pages.REPORTS_SERVICE_DETAIL],
    },
  },
];

export default routes;
